// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const merchantSettingsResource = '/settings/merchant'

export default {
  getMerchantSettingsResource() {
    return OperationRepository.get(`${merchantSettingsResource}`)
  },
}
